var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.size,"viewBox":"0 0 48 48","width":_vm.size,"fill":"currentColor"}},[_c('path',{attrs:{"d":"m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }